/**
 * Stops the drop down menu from closing when clicking on dates
 */
$(document).on('click.bs.dropdown.data-api', '.keep-open', function(e) {
    e.stopPropagation();
});

$(document).ready(function (){
    window.registerPopupEvents();
})



function drawPopupChart(box){
    let module = $("#" + box + "Module").val();
    let route = $("#chartRoute" + box).val();

    if(isGraphModule(module)){
        console.log("Is valid popup chart!!!")
        window.createChart(box, module, route);
    }else{
        console.log('not valid popup chart');
    }
}

/**
 * Resets the email modal and livewire upon closing
 */
$('#email-modal').on('hidden.bs.modal', function () {
    document.getElementById('email-loader').style.display = "none";
    document.getElementById('email-header').style.display = "block";
    document.getElementById('email-img-head').style.display = "inline";
    document.getElementById('btnSendEmail').style.display = "inline";
    document.getElementById('email-inputs').style.display = "flex";
    Livewire.emit('closeEmail');
});


/**
 * Sets The Query date in the respective box's livewire input fields from the boxes calendar menu
 */

window.setQueryDate = function(element) {
    console.group("Set Date");
    let box = element.id;
    let inputFromYear = $("#" + box + "CalendarFromYear");
    let inputFromMonth = $("#" + box + "CalendarFromMonth");
    let inputToYear = $("#" + box + "CalendarToYear");
    let inputToMonth = $("#" + box + "CalendarToMonth");

    console.log("New dates for " + element.id + ": " + inputFromYear.val(), inputFromMonth.val(), inputToYear.val(), inputToMonth.val());

    /**
     * Emit events so that livewire can update
     */
    const current = new Date();
    let annexure = 'annex' + box.slice(-1);
    console.log("Emitting to GraphBox");
    window.livewire.emit('graphUpdateDates' + box, box, inputFromYear.val(), inputFromMonth.val(), inputToYear.val() ?? current.getFullYear(), inputToMonth.val() ?? current.getMonth() + 1);
    console.log("Emitting to Annexure");
    window.livewire.emit('annexureUpdateDates' + annexure, annexure, inputFromYear.val(), inputFromMonth.val(), inputToYear.val() ?? 2022, inputToMonth.val() ?? 1);
    console.groupEnd();
}

window.setTableQueryDate = function(element) {
    console.group("Set Table Date");
    console.log("Setting Date values");
    let box = element.id;
    let inputFromYear = $("#" + box + "CalendarFromYear");
    let inputFromMonth = $("#" + box + "CalendarFromMonth");
    let inputToYear = $("#" + box + "CalendarToYear");
    let inputToMonth = $("#" + box + "CalendarToMonth");

    /**
     * Emit events so that livewire can update
     */
    console.log("Emitting to TableBox: " + 'tableUpdateDates' + box);
    window.livewire.emit('tableUpdateDates' + box, box, inputFromYear.val(), inputFromMonth.val(), inputToYear.val(), inputToMonth.val());
    console.groupEnd();
}


window.exportFile = function(url, name, extension, companyId) {

    $('#' + extension + '-date-picker-modal').modal('hide');
    $('#loading-export-modal').modal('show');

    const data = '';
    const year = document.getElementById(extension + '-year').value;
    const month = document.getElementById(extension + '-month').value;

    url = url.slice(0, -1);
    url = url + year + '-' + month;
    console.log('URL: ' + url);

    $.ajax({
        url:url,
        method:"GET",
        data: data,
        xhrFields: {
            responseType: 'blob'
        },

        success:function(response){

            console.log(response.size);

            if(typeof response.size === 'undefined') {
                console.log('Failed creating export');
                $('#loading-export-modal').modal('hide');
                window.location.href = '/home/' + companyId;
                return;
            }

            console.log('Successfully created export');

            let blob = new Blob([response]);


            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name.trim() + "." + extension;
            link.click();

            $('#loading-export-modal').modal('hide');
        }
    });
}

let chartModules = ["1","2","3","8", "9", "10", "12", "13" ,"15", "16"];

function isGraphModule(module){
    let includes = chartModules.includes(module);
    console.log("Does chartModules include " + module + "? " + includes);
    return includes;
}

window.registerPopupEvents = function (){
    unBindPopUpListeners();
    popupListeners();
}

function unBindPopUpListeners(){
    $("#popupModalbox1").unbind('show.bs.modal');
    $("#popupModalbox2").unbind('show.bs.modal');
    $("#popupModalbox3").unbind('show.bs.modal');
    $("#popupModalbox4").unbind('show.bs.modal');
    $("#popupModalbox5").unbind('show.bs.modal');
    $("#popupModalbox6").unbind('show.bs.modal');
    $("#popupModalbox7").unbind('show.bs.modal');
    $("#popupModalbox8").unbind('show.bs.modal');
}


function popupListeners(){
    $("#popupModalbox1").on('show.bs.modal',function(event){
        console.log("Drawing chart based on modal shown event!!!");
        drawPopupChart('box1popup');
    });
    $("#popupModalbox2").on('show.bs.modal',function(event){
        console.log("Drawing chart based on modal shown event!!!");
        drawPopupChart('box2popup');
    });
    $("#popupModalbox3").on('show.bs.modal',function(event){
        console.log("Drawing chart based on modal shown event!!!");
        drawPopupChart('box3popup');
    });
    $("#popupModalbox4").on('show.bs.modal',function(event){
        console.log("Drawing chart based on modal shown event!!!");
        drawPopupChart('box4popup');
    });
    $("#popupModalbox5").on('show.bs.modal',function(event){
        console.log("Drawing chart based on modal shown event!!!");
        drawPopupChart('box5popup');
    });
    $("#popupModalbox6").on('show.bs.modal',function(event){
        console.log("Drawing chart based on modal shown event!!!");
        drawPopupChart('box6popup');
    });
    $("#popupModalbox7").on('show.bs.modal',function(event){
        console.log("Drawing chart based on modal shown event!!!");
        drawPopupChart('box7popup');
    });
    $("#popupModalbox8").on('show.bs.modal',function(event){
        console.log("Drawing chart based on modal shown event!!!");
        drawPopupChart('box8popup');
    });
}
